//Console debugging.

// Which keys trigger debugging drawer, this is in conjunction with left clicking in the header.
const debugTriggerKeys = ['F2'];
//Debugging function 
var debug = Boolean(false);

// Static build whitelist.
const staticBuildHosts = [
    "express.staging.axisfirst.net",
    "localhost"
];
// As there is static build specific options check if current site is the static build.
const isStaticBuild = staticBuildCheck();


// TODO: Refine these levels: https://stackoverflow.com/questions/312378/debug-levels-when-writing-an-application 
var debugLevel = 1;

// Static build check.
function staticBuildCheck() {
    // Get current host.
    let currentHost = location.hostname;
    // Do check.
    let result = staticBuildHosts.includes(currentHost);
    return result;
}

//Check the debug status.
function debugStatus(status) {

    let previusStatus = (sessionStorage.getItem('debug') == 'true');

    // If no status is provided then look for previous status using session storage.
    if (status == undefined && previusStatus != undefined) {
        debug = previusStatus;
        // Also restore the level.
        debugLevel = setDebuglevel();
        return debug;
    }

    if (status != undefined) {
        // Store debug flag in session storage.
        sessionStorage.setItem('debug', status);
        // Set debug flag using session storage.
        debug = (sessionStorage.getItem('debug') == 'true');
        console.info("%cAXIS Debug Mode is " + (debug ? 'ACTIVE' : 'INACTIVE') + " .", "color: pink; font-size: 20px; font-weight: 700;");
    } else if (getUrlParameter("debug") == 1) {
        // Old way of setting debug mode through the url's querystring " ?debug=1&debug-level=3 "
        if (debug != true) {
            //Enable debugging console loggging.
            sessionStorage.setItem('debug', 'true');
            debug = true;
            console.info("AXIS JS Debug Mode Active!");
        }
    } else if (getUrlParameter("debug") == 0) {
         // Old way of setting debug mode through the url's querystring " ?debug=0&debug-level=3 "
            //Disable console loggging.
            sessionStorage.setItem('debug', 'false');
            debug = false;
            console.info("Disable AXIS JS Debug Mode");
    } else {
        //If no status is set in the URL.
        debug = sessionStorage.getItem('debug');  
        if (debug == "false") {
            debug = false;
        } else if (debug == "true") {
            debug = true;
        }
    }
    return debug;
};



function getCurrentTime() {
    //Initialise the Date object and get the current time.
    var timestamp = new Date();
    var currentTime = timestamp.toLocaleTimeString();
    return currentTime;
}

//Types of console messages + timestamp.
function outputMessage(type, msg, obj = "") {
    if (type == 1) {
        console.info("[" + getCurrentTime() + "] - " + msg, obj);
       
    } else if (type == 2) {
        console.warn("[" + getCurrentTime() + "] - " + msg);
    } else if (type == 3) {
        console.error("[" + getCurrentTime() + "] - " + msg);
    } else if (type == 4) {
        console.table(msg);
    } else {
        console.error("Notification type not selected");
    }
}

//Basic information about the client.
async function environmentInfo() {
    // Get current data + time.
    let currentDateTime  = new Date().toLocaleString();
    let storage = await getAvailableStorage();
    console.groupCollapsed("Basic Info");
    console.info("Javascript Initialised at: " + currentDateTime);
    console.info("Query string variables: " + location.search);
    console.info("Browser's language: " + navigator.language);
    console.info("Platform: " + navigator.userAgentData.platform);
    console.info("User Agent: " + navigator.userAgent);
    console.info("Cookies Enabled: " + navigator.cookieEnabled);
    console.info("Screen Resolution: " + parseInt(window.screen.width * window.devicePixelRatio) + "x" + parseInt(window.screen.height * window.devicePixelRatio));
    console.info("Window Outer Resolution: " + parseInt(window.outerWidth) + "x" + parseInt(window.outerHeight));
    console.info("Window Inner Resolution: " + parseInt(window.innerWidth) + "x" + parseInt(window.innerHeight));
    // deprecated
    //console.info("Browser Window Resolution: " + parseInt(window.innerWidth) + "x" + parseInt(window.innerHeight));
    console.info("Screen pixel radio / depth ( i.e scaling ): " + window.devicePixelRatio);
    console.info("Screen Colour Depth: " + screen.colorDepth);
    // deprecated
    //console.info("Browser: " + navigator.appName + " Version: " + navigator.appVersion);
    console.info("jQuery Version: " + jQuery().jquery);
    console.info("Foundation Version: " + Foundation.version);
    console.info("Breakpoint at time of Javascript Initialisation: " + Foundation.MediaQuery.current);
    console.info("Page Id: " + document.body.id);
    //console.info("Service Worker State: " + AXISServiceWorker.getState());
    console.info("Browser Supports Service Worker: " + ("serviceWorker" in navigator));
    
    console.info("Storage Quota: " , formatFileSize(storage['quota']));
    console.info("Storage Usage: ", formatFileSize(storage['usage']))
    if (storage.hasOwnProperty('usageDetails')) {
        for (let property in storage['usageDetails']) {
            console.log("Storage Usage Detail for " + property + ": ", formatFileSize(storage['usageDetails'][property]));
        }
    }
    console.groupEnd();
}

var instances = {};

function setContext(id, value) {
    return instances[id]['context'] = value;
}

function getContext(id) {
    return instances[id]['context'];
}

function setDebugDrawerPinState(state) {
    sessionStorage.setItem('debug-drawer-pinned', state);
    return getDebugDrawerPinState();
}

function getDebugDrawerPinState() {
    return (sessionStorage.getItem('debug-drawer-pinned') == 'true');
}

function setDebugDrawerActive(state) {
    sessionStorage.setItem('debug-drawer-active', state);
    return getDebugDrawerActive();
}

function getDebugDrawerActive() {
    return (sessionStorage.getItem('debug-drawer-active') == 'true');
}

function initalise() {
    // Check querystring.
    let querystring = getUrlParameter("axisdebug");
    // Parse value to Int.
    if (typeof(querystring) != "number") {
        querystring = querystring;
    }
    // Set value.
    if (querystring) {
        setDebuglevel(querystring);
        debugStatus(true);
    }

    // Clear local db via query string.
    let deleteIndexedDBQuery = getUrlParameter("axisDeleteLocalDb");
    deleteIndexedDBQuery = (deleteIndexedDBQuery == "true");
    if (deleteIndexedDBQuery) {
        indexedDbAvailable().then((e) => {
            indexedDBDeleteDb();
        }).catch((error) => {
            console.warn(error);
        });
    }
    
    // Clear local & session storage.
    let clearLocalSessionStorage = getUrlParameter("axisClearLocalStorage");
    clearLocalSessionStorage = (clearLocalSessionStorage == "true");
    if (clearLocalSessionStorage) {
        clearLocalStorage();
        clearSessionStorage();
    }

    $('header').on('mousedown', function() {
        let keys = {};
        $(document).on('keydown',function (event) {
            keys[event.key] = true;
            // Check if trigger keys are active, config for this is done by this variable debugTriggerKeys.
            let triggerKeys = triggerKeysActive(keys);
            if (triggerKeys) {
                // Check if instance exists.
                if ($('body').find('[data-axis-debugger]').length > 0) {
                    console.log("debugging found!");
                    // Get existing instance id.
                    let id = $('body').find('[data-axis-debugger]').attr('data-axis-debugger');
                    toggleDebugDrawer(id, true);
                } else {
                    debugDrawerInitialise().then((result) => {
                        let id = result['id'];
                        toggleDebugDrawer(id, true);
                    });
                }
            }
        });
        $(document).on('keyup', function(event) {
            delete keys[event.key];
        });
    });

    // Was the drawer previously active? 
    let drawerPreviouslyActive = getDebugDrawerActive();
    // Was the drawer previusly pinned?
    let drawerPreviouslyPinned = getDebugDrawerPinState();
    // Restore based on session storage.
    if (drawerPreviouslyActive || drawerPreviouslyPinned) {
        debugDrawerInitialise();
    }
    $('#headerContent').on('mouseup', function() {
        $(document).off('keydown');
        $(document).off('keyup');
    });
}

// Check against config if trigger keys are active.
function triggerKeysActive(activeKeys) {
    let isActive = debugTriggerKeys.every((key) => activeKeys.hasOwnProperty(key));
    return isActive;
}

// Run Drawer initialisation.
function debugDrawerInitialise(context) {
    return new Promise((resolve, reject) => {
        if (!context) {
            // Assume there is only one, this will have to be changed in the future if there are multiple...
            context = $('body').find('[data-axis-debugger]');
            // If container is not in DOM then create it.
            if (!context.length) {
                $('body').append('<div data-axis-debugger></div>');
                context = $('body').find('[data-axis-debugger]');
            }
        }
        // Get instance id.
        let id = context.attr('data-axis-debugger');
        // Check session storage.
        let drawerPreviouslyActive = getDebugDrawerActive();
        let drawerPreviouslyPinned = getDebugDrawerPinState();
        // Check whether previously initialised.
        if (!id) {
            // Generate Id.
            id = generateId();
            // Add id to context.
            context.attr('data-axis-debugger', id);
            // Create instance.
            instances[id] = {};
            setContext(id, context);
            buildDevNav(id).then((result) => {
                // Add listeners.
                devControls(id);
                if (drawerPreviouslyActive) {
                    toggleDebugDrawer(id, true);
                }
                if (drawerPreviouslyPinned) {
                    drawerTogglePin(id, true);   
                }
                resolve({id: id});
            }).catch((error) => {
                reject(error);
            });
        } else {
            toggleDebugDrawer(id);
            resolve({id: id});
        }
    });
}

async function buildDevNav(id) {
    let context = $('body').find('[data-axis-debugger=' + id +']');
    let testModeUrl = window.location.href + "?axistestmode=1";
    // If url has query string variables.
    if (window.location.search != "") {
        testModeUrl = window.location.href + "&axistestmode=1";
    }

    // Check if site style is configured at the body.
    let siteStylesActive = $('body').hasClass('site-style');
    let siteStyleButtons = "";
    if (siteStylesActive) {
        siteStyleButtons = `
            <li data-debugger-option-container  class="debug-option-container">
                <a class="option-trigger site-style" title="This site has site styles configured, this is currently limited to 5 options" data-debugger-option-trigger="site-style-toggle"><span class="option-description">Site Style</span></a>
                <ul data-debugger-additional-options-container>
                    <li class="additional-option">
                        <form>
                            <label class="control text">
                                <span class="label">Current Style:</span>
                                <input type="number" name="site-style-change" min="1" max="${getSiteStyleMax()}" value="${getCurrentSiteStyle()}" data-debugger-additional-option>
                            </label>
                        </form>
                    </li>
                </ul>
           </li>`
    }

    let storage = await getAvailableStorage();
    // Check if browser support detailed breakdown.
    let detailedBreakdown = storage.hasOwnProperty('usageDetails');
    let detailedBreakdownMarkup = `
        <li>
            <span class="information-heading">Usage Breakdown</span>
            <ul class="info-breakdown">
                ${generateDetailStorageBreakdown(storage)}
            </ul>
        </li>
    `;

    let storageManagerInfo = `
        <li data-debugger-option-container  class="debug-option-container">
            <a title="Local storage being used by this site" class="option-trigger storage-manager" data-debugger-option-trigger="storage-manager">
                <span class="option-description">Local Storage</span>
            </a>
            <ul data-debugger-additional-options-container>
                <li class="info-option" title="Conservative approximation of the total storage the user's device">
                    <span class="label">Available Disc Storage</span>
                    <span class="value">${formatFileSize(storage['quota'])}</span>
                </li>
                <li class="info-option" title="Total disk space used by local database, cache(s), service worker(s)">
                    <span class="label">Total Disc Storage Used</span>
                    <span class="value">${formatFileSize(storage['usage'])}</span>
                </li>
                    ${detailedBreakdown ? detailedBreakdownMarkup : ''}
                <li class="additional-option">
                    <div class="additional-option-button-container">
                        <span class="label">Clear Local Storage ( Max 5MB )</span>
                        <button type="button" class="action-button alert" data-debugger-additional-option="local-storage-clear">Clear</button>
                    </div>
                </li>
                <li class="additional-option">
                    <div class="additional-option-button-container">
                        <span class="label">Clear Session Storage ( Max 5MB )</span>
                        <button type="button" class="action-button alert" data-debugger-additional-option="session-storage-clear">Clear</button>
                    </div>
                </li>
            </ul>
        </li>
    `;

    // Additional checks not all browsers currently support this.
    let indexedDbDetailedUsage = (storage.hasOwnProperty('usageDetails') ? (storage['usageDetails'].hasOwnProperty('indexedDB') ? storage['usageDetails']['indexedDB'] : false) : false);
    if (indexedDbDetailedUsage) {
        indexedDbDetailedUsage = `
            <li class="info-option">
                <span class="label">Storage Used</span>
                <span class="value">${formatFileSize(indexedDbDetailedUsage)}</span>
            </li>
        `;
    }
    let indexedDbOptions = `
        <li data-debugger-option-container  class="debug-option-container">
            <a title="This has a local database attached" class="option-trigger indexeddb" data-debugger-option-trigger="indexeddb-toggle">
                <span class="option-description">IndexedDB</span>
            </a>
            <ul data-debugger-additional-options-container>
                ${(indexedDbDetailedUsage ? indexedDbDetailedUsage : '')}
                <li class="additional-option">
                    <div class="additional-option-button-container">
                        <button type="button" class="action-button alert" data-debugger-additional-option="indexeddb-delete-database">Delete Database</button>
                    </div>
                </li>
            </ul>
        </li>
    `;
    
    let serviceWorkerSupported = AXISServiceWorker.supported();
    let serviceWorkerOptions = `
        <li data-debugger-option-container  class="debug-option-container">
                <a title="Service Worker is required for PWA Support" class="option-trigger service-worker" data-debugger-option-trigger="site-style-toggle">
                    <span class="option-description">Service Worker</span
                ></a>
                <ul data-debugger-additional-options-container>
                    <li class="info-option">
                        <span class="label">Status</span>
                        <span class="value" id="service-worker-status">${AXISServiceWorker.getState()}</span>
                    </li>
                    <li class="additional-option">
                        <div class="additional-option-button-container">
                            <span class="label">Check for updates</span>
                            <button type="button" class="action-button warning" data-debugger-additional-option="update-service-worker">Update</button>
                        </div>
                    </li>
                    <li class="additional-option" title="Uninistall the server worker for this site, this interrupt any PWA installation.">
                        <div class="additional-option-button-container">
                            <span class="label">Unregister</span>
                            <button type="button" class="action-button alert" data-debugger-additional-option="unregister-service-worker">Remove</button>
                        </div>
                    </li>
                </ul>
           </li>
    `;

    let pauseContentRefresh = `
        <li data-debugger-option-container  class="debug-option-container ${getPauseContentRefreshFlag() ? 'active' : ''}">
             <a title="Pause content automatic refresh ( i.e manage calls )" class="option-trigger pause-content-refresh" data-debugger-option-trigger="pause-content-refresh">
                    <span class="option-description">Pause Content Refresh</span></a>
        </li>
    `;

    let markup = `
        <div class="development-drawer">
            <div class="drawer-header">
                <div class="heading-container">
                    <h2>Site Diagnostics</h2>
                </div>
            </div>
            <div class="options-container">
                <ul>
                    ${storageManagerInfo}
                    ${indexedDbOptions}
                    ${(serviceWorkerSupported ? serviceWorkerOptions : '')}
                    <li data-debugger-option-container class="debug-option-container ${(debugStatus() ? "active" : "")}">
                        <a title="Set how verbose the console logging is" class="option-trigger set-debugging-level" data-debugger-option-trigger="console-logging"><span class="option-description">Console Logging</span></a>
                        <ul data-debugger-additional-options-container>
                            <li class="additional-option">
                                <form>
                                    <label class="control slider">
                                        <span class="label">Debug Level: <span data-slider-value="console-logging-level">${(debugStatus() ? setDebuglevel() : 1)}</span></span>
                                        <input type="range" name="console-logging-level" min="1" max="4" value="${(debugStatus() ? setDebuglevel() : 1)}" class="control-slider" data-debugger-additional-option />
                                    </label>
                                </form>
                            </li>
                        </ul>
                    </li>
                    <li class="debug-option-container">
                        <a href="${testModeUrl}" title="Enable website test mode" class="option-trigger axis-test-mode" test-mode><span class="option-description">Test Mode</span></a>
                    </li>
                    ${pauseContentRefresh}
                    ${siteStyleButtons}
                </ul>
            </div>
            <div class="drawer-footer">
                <button type="button" title="Toggle drawer open/close state" class="debugger-close-button" debugger-close-button><span class="footer-button-description">Close</span></button> 
                <button type="button" title="Never completely close the drawer for this session" class="debug-drawer-pin" data-debug-pin><span class="footer-button-description">Pin</span></button>
            </div>
        </div>
    `;
    // Update DOM.
    context.append(markup);
    // Add class(s).
    context.addClass('development-drawer-container');
    // Find in DOM.
    context = $('[data-axis-debugger="' + id + '"]');
    return Promise.resolve({"context": context});
}

function devControls(id) {
    // Get context.
    let context = getContext(id);
    // Close debugger.
    $('[data-axis-debugger=' + id + '] [debugger-close-button]').on('click', function(event) {
        event.preventDefault();
        toggleDebugDrawer(id, false);
    });

    // Debug option trigger, this is use to toggle functionality in itself ( i.e console logging ) but have additional configurations availabe such as console logging level. 
    context.find('[data-debugger-option-trigger]').on('click', function(event) {
        event.preventDefault();
        // Get context.
        let option = $(this);
        // Check if drawer is active.
        if (!context.hasClass('active')) {
            context.addClass('active');
        }
        // Get container.
        let container = option.parent('[data-debugger-option-container]');
        // What sort of action is this?
        let action = option.attr('data-debugger-option-trigger');
        if (!action) {
            console.log("Please provide a action for this option");
            return false;
        }
        let result = toggleDebugAdditionOption(option, action);
        // toggle active class.
        container.toggleClass('active');
    });

    // Used to add additional configuration to the trigger, i.e how verbose the console is.
    context.find('[data-debugger-additional-option]').on('change', function(event) {
        event.preventDefault();
        // Get context.
        let option = $(this);
        additionalOptionTriggered(option);
    });

    context.find('button[data-debugger-additional-option]').on('click', function(event) {
        event.preventDefault();
        // Get context.
        let option = $(this);
        additionalOptionTriggered(option);
    });

    // Whether to pin the drawer to the edge of the screen when closed.
    $('button[data-debug-pin]').on('click', function(event) {
        event.preventDefault();
        drawerTogglePin(id);
    });
}

// Build detailed storage breakdown.
function generateDetailStorageBreakdown(storage) {
    let markup = "";
    for (let property in storage['usageDetails']) {
        markup = markup + `
            <li class="info-option" title="${detailedStorageDescriptions(property)}">
                <span class="label">${property}</span>
                <span class="value">${formatFileSize(storage['usageDetails'][property])}</span>
            </li>
        `;
    }
    return markup;
}

// Add title to detailed storeage breakdown describing their purpose.
function detailedStorageDescriptions(property) {
    let title = new String;
    switch(property) {
        case "caches": 
            title = "Local Cache(s) such as images and pages used for the Service Worker.";
            break;
        case "indexedDB":
            title = "Local Database";
            break;
        case "serviceWorkerRegistrations":
            title = "Background Worker(s) that operate outside of the main thread, this is a requirement for PWA support";
            break;
        default:
            title = "-";
    }
    return title;
}

// Toggle active state for debugging drawaer.
function toggleDebugDrawer(id, state) {
    if (!state) {
        state = getDebugDrawerActive();
        // Revert value.
        state = !state;
    }
    let context = getContext(id);
    if (state) {
        setDebugDrawerActive(true);
        context.addClass('active');
    } else {
        setDebugDrawerActive(false);
        context.removeClass('active');
    }
    return setDebugDrawerActive(state);
}

// Toggle Pinned state for debugging drawer, you can provide state to manually toggle or the session value gets used to determine the outcome.
function drawerTogglePin(id, state) {
    if (!state) {
        state = getDebugDrawerPinState();
        // Revert value.
        state = !state;
    }
    // Get context.
    let context = getContext(id);
    if (state) {
        context.addClass('drawer-pinned');
    } else if (context.hasClass('drawer-pinned')) {
        context.removeClass('drawer-pinned')
    }
    return setDebugDrawerPinState(state);
}

function additionalOptionTriggered(context) {
    // What sort of action is this?
    let action = context.attr('data-debugger-additional-option');
    // Fallback to name.
    if (!action) {
        action = context.attr('name');
    }
    let result = toggleDebugAdditionOption(context, action);
}

function toggleDebugAdditionOption(input, action) {
    if (!action) {
        console.error("Please provide an action you wish to toggle");
    }

    let completedAction;
    switch(action) {
        case "console-logging":
            completedAction = toggleConsoleLogging();
            break;
        case "console-logging-level":
            completedAction = setConsoleLoggingLevel(input);
            break;
        case "site-style-toggle":
            completedAction = true;
            break;
        case "site-style-change":
            completedAction = siteStyleChange(input);
            break;
        case "indexeddb-toggle":
            completedAction = true;
            break;
        case "indexeddb-delete-database":
            completedAction = indexedDBDeleteDb();
            break;
        case "storage-manager":
            completedAction = true;
            break;
        case "local-storage-clear":
            completedAction = clearLocalStorage();
            break;
        case "session-storage-clear":
            completedAction = clearSessionStorage();
            break;
        case "update-service-worker":
            completedAction = updateServiceWorker();
            break;
        case "unregister-service-worker": 
            completedAction = unregisterServiceWorker();
            break;
        case "pause-content-refresh": 
            completedAction = togglePauseContentRefresh();
            break;
        default:
            console.error("Sorry that action is not supported.", action);
            completedAction = false;
    }
    return completedAction;
}

// Pause content refresh.
function togglePauseContentRefresh() {
    // Check session storage.
    let pauseFlag = getPauseContentRefreshFlag();
    // Invert.
    pauseFlag = !pauseFlag;
    // Set.
    sessionStorage.setItem('content-refresh-paused', pauseFlag);
    return pauseFlag;
}

function getPauseContentRefreshFlag() {
    return (sessionStorage.getItem('content-refresh-paused') == 'true');
}

// Clear all LocalStorage keys.
function clearLocalStorage() {
    return localStorage.clear();
}

// Clear all SessionStorage Keys.
function clearSessionStorage() {
    return sessionStorage.clear();
}

async function getAvailableStorage() {
    let storage = await axisLocalStorageManager.getEstimate();
    return storage;
}

// Check for updates
async function updateServiceWorker() {
    try {
        let result = await AXISServiceWorker.update();
        callouts.create("Worker Update Process Complete", 0);
    } catch (error) {
        console.error(error);
    }
}

// Unregister worker.
function unregisterServiceWorker() {
    AXISServiceWorker.remove();
    return true;
}


// Check if this site Database is available.
function indexedDbAvailable() {
    return axisIndexedDb.databaseAvailable()
}

// Delete / Drop this site's Database.
function indexedDBDeleteDb() {
    let deleteDb = axisIndexedDb.deleteDatabase()
    return deleteDb;
}

// Modify the style being used on the body.
function siteStyleChange(input) {
    // Get body context.
    let body = $('body');
    let maxSiteStyle = getSiteStyleMax();
    let value = input.val();
    // Basic validation ...
    if (value > 0 && value <= maxSiteStyle) {
        // Remove any styles previously applied.
        for (let style = 1; style <= maxSiteStyle; style++) {
            if (body.hasClass('style-' + style)) {
                body.removeClass('style-' + style);
                break;
            }
        }
        body.addClass('style-' + value);
        return value;
    } else {
        console.warn("Site Style: Sorry that configuration is not supported.", value);
        return false;
    }
}

// Work out max configured site-styles via CSS variable generated via SASS.
function getSiteStyleMax() {
    let body = $('body');
    let max = body.css('--site-styles-max');
    if (!max) {
        max = 0;
    }
    return max;
}

// Get the stite style that is currently being used, this could be improved by caching the value but for debug purposes this will be ok.
function getCurrentSiteStyle() {
    let body = $('body');
    let maxSiteStyle = getSiteStyleMax();
    let currentStyle = undefined;
    // Loop over configured style and find out which one is appled to the body.
    for (let style = 1; style <= maxSiteStyle; style++) {
        if (body.hasClass('style-' + style)) {
            currentStyle = style;
            break;
        }
    }
    return currentStyle;
}

// Toggle console logging.
function toggleConsoleLogging() {
    let currentState = debugStatus();
    return debugStatus(!currentState);
}

/*
    Set how verbose the logging in the console is.
    1. Show Errors.
    2. Show Warning.
    3. Show General Info i.e initalisation's of modules & configurations, AJAX callback configs.
    4. Very verbose Info logging i.e carousel resizing, form validation, input state changes.

    This is a essentially a wrapper function for setDebuglevel().
*/

function setConsoleLoggingLevel(input) {
    if (!input.length) {
        console.error("Could not find an input to set console log level.", input);
        return false;
    }
    // Get Value.
    let value = input.val();
    // Set level.
    let level = setDebuglevel(value);
    // Get input id.
    let id = input.attr('id');
    // Fallback.
    if (!id) {
        id = input.attr('name');
    }
    if (id) {
        // Because this is most likely a slider then output the value in a number format for accessability.
        let outputElement = $('[data-slider-value="' + id + '"]');
        outputElement.html(level);
    }
    return level;
}


function setDebuglevel(level) {
    if (sessionStorage.getItem("debug") != "true") {
        return false;
    }
    // Get Previous level from session storage.
    let previousDebugLevel = parseInt(sessionStorage.getItem('debug-level'));

    // If no level is defined then check url.
    if (level == undefined) {
        // Get url debug level.
        level = getUrlParameter("debug-level");
    }
    // If level still not defined and there is a previous debug level in session storage then use that.
    if (level == undefined && previousDebugLevel) {
        level = previousDebugLevel;
    }
    // If requested level = debug level when exit function.
    if (level == debugLevel) {
        // debugLevel is insync with url then return debug level.
        return debugLevel;
    }

    // If still not defined then default to 1.
    if (!level) {
        level = 1;
    }

    // Set debug level in session storage.
    sessionStorage.setItem('debug-level', level);
    debugLevel = sessionStorage.getItem('debug-level');
    console.info("AXIS JS Debug Level " + debugLevel + " Selected");

    return debugLevel;
}

function getDebugOptionValue(optionName) {
    if (!optionName) {
        console.error("Please provide the name of the debug option.");
        return false;
    }
    // Get option from session storage.
    let value = sessionStorage.getItem(optionName);
    // Option has not been set yet.*
    if (value == null) {
        return false;
    }
    return value;
}

// Function update a status indicator.
function updateStatusIndicator(id, value) {
    // Get element context.
    let element = $('#' + id);
    if (!element.length) {
        return false;
    }
    // Is input? 
    // TODO: this to be extended later for checkbox, ratio, selector, textarea support.
    let isInput = (element.is('input') ? true : false);
    // If the indicator is a input then default to value.
    if (isInput) {
        element.val(value)
    } else {
        element.html(value);
    }
}

var AXISDebug = $.AXISDebug = {
    initialise: () => {
        //  TODO: This is a work in progess.
        return initalise();

    },
    enabled: () => {
        return debugStatus();
    },
    output: (consoleType, msg, obj = "", isGroup = {enabled:false, operate: 0, description: ""}) => {
        if (debugStatus()) {
            if (isGroup.enabled) {
                if (isGroup.operate == 1) { 
                    console.groupCollapsed(isGroup.description);
                    if (msg.length > 0) {
                        outputMessage(consoleType, msg, obj);
                    }
                } else if (isGroup.operate == 0) {
                    console.groupEnd();
                } else {
                    console.error("The Operate parameter needs to be set, this parameter indicates whether to open or close the the console group.");
                }
            } else {
                outputMessage(consoleType, msg, obj);
            }
        }
    },
    level: () => {
        // Get url debug level.
        let sessionDebugLevel = getUrlParameter("debug-level");
        if (sessionDebugLevel == debugLevel) {
            // debugLevel is insync with url then return debug level.
            return debugLevel;
        }
        if (sessionDebugLevel >= 1) {
            // Set debug level in session storage.
            sessionStorage.setItem('debug-level', sessionDebugLevel);
            // Replace debug level from session storage ( just to make sure everything is in sync ).
            debugLevel = sessionStorage.getItem('debug-level');
            console.info("AXIS JS Debug Level " + debugLevel + " Selected");
        } else {
            // If no status is set in the URL use the session storage.
            // If session debug is defined then use that otherwise use default.
            if (sessionDebugLevel) {
                debugLevel = sessionDebugLevel;
            }
        }
        return debugLevel;
    },
    environmentInfo: () => {
        if (AXISDebug.enabled() != true) {
            return false;
        }
        if (debug) {
            environmentInfo();
        }
    },
    getDebugOptionValue: (optionName) => {
        return getDebugOptionValue(optionName);
    },
    getDebugDrawerState: () => {
        return getDebugDrawerActive();
    },
    updateDrawerStatus: (id, value) => {
        return updateStatusIndicator(id, value);
    }
}

export { AXISDebug };